import { useLocationQuery } from '@web/helpers/hooks';

export const useIncludeEntityData = () => {
  const query = useLocationQuery();
  return query.get('includePrivate') === 'true';
};
